import { combineReducers } from 'redux'
import data from './data'
import list from './list'

export default (resource, options) =>
  combineReducers({
    data: data(resource, options),
    list: list(resource, options),
  })



// WEBPACK FOOTER //
// ./state/reducers/resource/index.js